import { createTheme } from '@mui/material/styles';

import Color from '@/tool/color';

const ThemeConfig = createTheme({
  // 改变 material-ui 主色
  palette: {
    primary: {
      main: Color.primary,
      dark: Color.primaryDark,
    },
    secondary: {
      main: Color.secondary,
      dark: Color.secondaryDark,
    },
    success: {
      main: Color.success,
      dark: Color.successDark,
    },
    warning: {
      main: Color.warning,
      dark: Color.warningDark,
    },
    error: {
      main: Color.error,
      dark: Color.errorDark,
    },
  },

  // 改变全局 material-ui 字体
  typography: {
    fontFamily: [
      'PingFang SC',
      'PingFang SC Medium',
      'PingFangSC Regular',
      'system-ui',
      'sans-serif',
    ].join(','),
  },

  // 覆盖组件样式
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minWidth: 0,
          textTransform: 'none',
          borderRadius: 0,
          lineHeight: 1.5,
          boxShadow: 'none',

          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          height: 'auto',
          lineHeight: 1.5,
        },
        input: {
          height: 'auto',
          fontSize: '14px',
          lineHeight: 1.5,
        },
      },
    },
  },
});

export default ThemeConfig;
